import React from 'react';
import { View } from 'react-native';

export default ({ children, style }) => <View style={style}>{children}</View>;



// WEBPACK FOOTER //
// ./node_modules/react-native-safe-area-view/index.web.js